/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getActorFeeds.defs.js'
export * as $defs from './getActorFeeds.defs.js'
